export default "__VITE_ASSET__CNOj2bbC__"